<script setup lang="ts">
withDefaults(defineProps<{ size?: number | string; color?: string }>(), {
  size: 24,
  color: "currentColor",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :width="size"
    :height="size"
    :fill="color"
    v-bind="$attrs"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.199 18.4718C15.5062 19.8795 13.3302 20.7261 10.9565 20.7261C5.56093 20.7261 1.18695 16.3521 1.18695 10.9565C1.18695 5.56093 5.56093 1.18695 10.9565 1.18695C16.3521 1.18695 20.7261 5.56093 20.7261 10.9565C20.7261 13.3302 19.8795 15.5062 18.4718 17.199L22.5494 21.2766C22.9009 21.6281 22.9009 22.198 22.5494 22.5494C22.198 22.9009 21.6281 22.9009 21.2766 22.5494L17.199 18.4718ZM2.98695 10.9565C2.98695 6.55505 6.55505 2.98695 10.9565 2.98695C15.358 2.98695 18.9261 6.55505 18.9261 10.9565C18.9261 13.1005 18.0795 15.0467 16.7024 16.4791C16.6597 16.5089 16.6191 16.5429 16.581 16.581C16.5429 16.6191 16.5089 16.6597 16.4791 16.7024C15.0467 18.0795 13.1005 18.9261 10.9565 18.9261C6.55505 18.9261 2.98695 15.358 2.98695 10.9565Z"
    />
  </svg>
</template>
